module.exports = __webpack_public_path__ + "static/media/sam-bigdeli-1-250x250.70e768b2.jpg";